import { Box, Paper, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

const PriceSidebar = ({ cartItems, showDeliveryCharge = false }) => {
    const theme = useTheme();
    const [usdToInrRate, setUsdToInrRate] = useState(null);
    const { shippingInfo } = useSelector((state) => state.cart);

    useEffect(() => {
        axios.get('https://api.exchangerate-api.com/v4/latest/USD')
            .then(response => {
                setUsdToInrRate(response.data.rates.INR);
            })
            .catch(error => {
                console.error("Error fetching exchange rate", error);
                setUsdToInrRate(88.79); // fallback rate
            });
    }, []);

    const itemsPrice = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalMrp = cartItems.reduce((sum, item) => sum + (item.mrp * item.quantity), 0);
    const totalDiscount = totalMrp - itemsPrice;
    const shippingCharges = cartItems.reduce((sum, item) => sum + (item.deliveryCharges * item.quantity), 0);
    const totalAmount = itemsPrice + (showDeliveryCharge ? shippingCharges : 0);

    return (
        <Paper elevation={3} sx={{ p: 3, position: 'sticky', top: '6rem', bgcolor: 'background.paper' }}>
            <Typography variant="h6" gutterBottom sx={{ color: theme.palette.text.secondary }}>
                PRICE DETAILS
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 1 }}>
                <Typography>Price ({cartItems.length} item)</Typography>
                <Box>
                    <Typography component="span">₹{totalMrp.toLocaleString()}</Typography>
                    {usdToInrRate && (
                        <Typography variant="body2" component="span" sx={{ ml: 1, color: theme.palette.text.secondary }}>
                            / ${(totalMrp / usdToInrRate).toFixed(2)}
                        </Typography>
                    )}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 1 }}>
                <Typography>Discount</Typography>
                <Box>
                    <Typography component="span" sx={{ color: theme.palette.success.main }}>- ₹{totalDiscount.toLocaleString()}</Typography>
                    {usdToInrRate && (
                        <Typography variant="body2" component="span" sx={{ ml: 1, color: theme.palette.text.secondary }}>
                            / ${(totalDiscount / usdToInrRate).toFixed(2)}
                        </Typography>
                    )}
                </Box>
            </Box>
            {showDeliveryCharge && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 1 }}>
                    <Typography>Delivery Charges</Typography>
                    {shippingCharges === 0 ? (
                        <Typography sx={{ color: theme.palette.success.main }}>FREE</Typography>
                    ) : (
                        <Box>
                            <Typography component="span">₹{shippingCharges}</Typography>
                            {usdToInrRate && (
                                <Typography variant="body2" component="span" sx={{ ml: 1, color: theme.palette.text.secondary }}>
                                    / ${(shippingCharges / usdToInrRate).toFixed(2)}
                                </Typography>
                            )}
                        </Box>
                    )}
                </Box>
            )}
            <Divider sx={{ my: 2, borderStyle: 'dashed' }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 1 }}>
                <Typography variant="h6">Total Amount</Typography>
                <Box>
                    <Typography variant="h6" component="span">₹{totalAmount.toLocaleString()}</Typography>
                    {usdToInrRate && (
                        <Typography variant="body2" component="span" sx={{ ml: 1, color: theme.palette.text.secondary }}>
                            / ${((totalAmount / usdToInrRate) + 10).toFixed(2)}
                        </Typography>
                    )}
                </Box>
            </Box>
            <Divider sx={{ my: 2, borderStyle: 'dashed' }} />
            <Box sx={{ color: theme.palette.success.main, fontWeight: 'bold' }}>
                <Typography component="span" sx={{ color: theme.palette.success.main, fontWeight: 'bold' }}>You will save ₹{totalDiscount.toLocaleString()} on this order</Typography>
                {usdToInrRate && (
                    <Typography variant="body2" component="span" sx={{ ml: 1, color: theme.palette.text.secondary }}>
                        / ${(totalDiscount / usdToInrRate).toFixed(2)}
                    </Typography>
                )}
            </Box>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mt: 2, textAlign: 'center', display: 'block' }}>
                (Inclusive of all taxes)
            </Typography>
        </Paper>
    );
};

export default PriceSidebar;